



import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import ECharts from "vue-echarts";
@Component({
  components: { ECharts }
})
export default class PdMonitorChart extends AbpBase {
  @Prop() data: any;
  options :any={};

  @Watch("data", { immediate: true, deep: true })
  async onDataChanged() {
    await this.creatOptions();
    if (this.data) {
      let xAxisData: any = [];
      this.data.xAxisData.forEach((item: string) => {
        xAxisData.push(item);
      });
      let legendData: any = [];
      let series: any = [];
      this.data.seriesData.forEach((item: any) => {
        legendData.push(item.name);
        let seriesItem: any = {
          name: item.name,
          type: "line",
          data: []
        };
        item.data.forEach((val: any) => {
          seriesItem.data.push(val);
        });
        series.push(seriesItem);
      });
      this.options.title.text = this.data.title;
      this.options.title.subtext = this.data.subTitle;
      this.options.legend.data = legendData;
      this.options.xAxis[0].data = xAxisData;
      this.options.yAxis[0].axisLabel.formatter = "{value} " + this.data.unit;
      this.options.series = series;
    }
  }
  creatOptions() {
    this.options = {
      title: {
        text: "",
        subtext: ""
      },
      tooltip: {
        trigger: "axis"
      },
      legend: {
        data: []
      },
      toolbox: {
        show: true,
        feature: {
          mark: { show: true },
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ["line", "bar"] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          data: []
        }
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: ""
          }
        }
      ],
      series: []
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/chart.vue